import {Typography} from '@mui/material'
import { Box } from '@mui/system'
import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'
import Table from './Table/Table'
import { useDefaultComponentTools } from '../../../../../hooks/useDefaultComponentTools'
import {
	selectFilteredPositionsArr,
	selectPositionsTab
} from '../../../../../store/redusers/positions/selectors'
import { AppSpin } from '../../../../AppSpin'
import { cellsObj } from '../types'

const PositionsTable = ({isFetchData}) => {
	const currentListPositionsIds = useSelector(selectFilteredPositionsArr)
	const positionsTab = useSelector(selectPositionsTab)
	const {lgUp, t } = useDefaultComponentTools()

	return (
		<Box sx={{height: lgUp ? '100%' : '300px', minWidth: '756px'}}>
			{isFetchData ?
				<AppSpin  size={10}/> :
				(!currentListPositionsIds ?
					<Typography sx={{p: '15px'}}>{t(`No ${positionsTab} trades`)}</Typography> :
					<Table
						currentTab={positionsTab}
						positionsIds={currentListPositionsIds}
						titles={cellsObj[positionsTab]}
					/>
				)
			}
		</Box>
	)
}

PositionsTable.propTypes = {
	isFetchData: PropTypes.bool
}

PositionsTable.displayName = 'PositionsTable'

export default PositionsTable
